module.exports = __webpack_public_path__ + "img/f82a853.jpg";